export const CONTAINS_SPECIAL_CHARACTER = /(?=.*[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])/;
export const CONTAINS_NUMBER = /\d+/;
export const CONTAINS_UPPERCASE = /(?=.*[A-Z])/;
export const CONTAINS_LOWERCASE = /(?=.*[a-z])/;
export const CONTAINS_UNTRIMMED_WHITESPACE = /^\s|\s$/;

export interface ErrorHashProp {
  length: boolean;
  number: boolean;
  specialChar: boolean;
  uppercase: boolean;
  lowercase: boolean;
  trimmedWhiteSpace: boolean;
}

// returns error hash that lets us know which password requirement is not satisfied
export const checkPasswordStrength = (password: string, minLength = 15): ErrorHashProp => {
  const errorHash = {
    length: false,
    number: false,
    specialChar: false,
    uppercase: false,
    lowercase: false,
    trimmedWhiteSpace: false,
  };

  if (password.length >= minLength) errorHash.length = true;
  if (RegExp(CONTAINS_NUMBER).test(password)) errorHash.number = true;
  if (RegExp(CONTAINS_SPECIAL_CHARACTER).test(password)) errorHash.specialChar = true;
  if (RegExp(CONTAINS_UPPERCASE).test(password)) errorHash.uppercase = true;
  if (RegExp(CONTAINS_LOWERCASE).test(password)) errorHash.lowercase = true;
  if (!RegExp(CONTAINS_UNTRIMMED_WHITESPACE).test(password)) errorHash.trimmedWhiteSpace = true;

  return errorHash;
};
